import { ChevronDown, LogOut, UserRound } from "lucide-react";
import { useNavigate } from "react-router";
import { useOperatorSession, useSignOut } from "@/shared/auth/session";
import { ROUTES } from "@/shared/constants/routes";
import { Button } from "@/shared/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/shared/ui/dropdown-menu";
import { Icon } from "@/shared/ui/icon";
import { operatorRolePresentation, personLabel } from "@/shared/utils/labels";

/** The operator's name and role, and "Sign out" (ends the operator session and the customer session behind it). */
export function UserMenu() {
  const { operator, sessionMinutes } = useOperatorSession();
  const navigate = useNavigate();
  const signOut = useSignOut(() => void navigate(ROUTES.login, { replace: true }));
  const display = personLabel(operator.name, operator.mobile);
  const role = operatorRolePresentation(operator.role).label;
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className="max-w-64 gap-1.5"
          aria-label={`Account menu for ${display}`}
          loading={signOut.isPending}
        >
          <span className="inline-flex size-6 items-center justify-center rounded-full bg-accent-soft text-caption font-semibold text-accent-fg">
            {operator.name ? (
              operator.name.slice(0, 1).toUpperCase()
            ) : (
              <Icon icon={UserRound} size={16} className="size-3.5" />
            )}
          </span>
          <span className="hidden truncate md:inline">{display}</span>
          <span className="hidden text-caption text-fg-muted md:inline">· {role}</span>
          <Icon icon={ChevronDown} size={16} />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-56">
        <DropdownMenuLabel>
          <span className="block truncate text-cell font-medium text-fg">{display}</span>
          <span className="block truncate">{role} · Nexborg operator</span>
          <span className="block truncate font-mono">{operator.mobile}</span>
          <span className="block truncate">Operator sessions last {sessionMinutes} min</span>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem tone="danger" onSelect={() => signOut.mutate()} disabled={signOut.isPending}>
          <Icon icon={LogOut} size={16} />
          Sign out
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
